import type { JSX, ChangeEvent } from "react";
import { useState } from "react";

import { translate } from "app/filters/i18nFilter";
import { TextArea, PlaceHolder, EmailContainer } from "./InviteTeammatesNotification.styled";

interface IInviteTeammatesNotificationProps {
    notification: string;
    onChangeNotification: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const InviteTeammatesNotification = ({
    notification,
    onChangeNotification,
}: IInviteTeammatesNotificationProps): JSX.Element => {
    const [showPlaceHolder, setShowPlaceHolder] = useState<boolean>(true);

    const onTextChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        if (showPlaceHolder) {
            setShowPlaceHolder(false);
        }
        onChangeNotification(event);
    };

    return (
        <EmailContainer>
            <TextArea
                value={notification}
                onChange={onTextChange}
            />
            <PlaceHolder isVisible={showPlaceHolder}>
                {translate("asset.sharing.notification.content.placeholder")}
            </PlaceHolder>
        </EmailContainer>
    );
};
